var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 20.9297C15.1049 20.9297 14.355 21.6796 14.355 22.5742C14.355 23.4688 15.1049 24.2187 15.9995 24.2187C16.8612 24.2187 17.644 23.4688 17.6046 22.6137C17.644 21.673 16.9007 20.9297 15.9995 20.9297Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2213 26.7597C32.2541 24.9771 32.2607 22.8524 31.2345 21.0763L20.9332 3.23647C19.9136 1.44065 18.0717 0.375 16.0062 0.375C13.9407 0.375 12.0988 1.44723 11.0792 3.22989L0.764735 21.0894C-0.261448 22.8852 -0.25487 25.0231 0.784469 26.8058C1.81065 28.5687 3.64594 29.6278 5.69831 29.6278H26.2746C28.3335 29.6278 30.182 28.5556 31.2213 26.7597ZM28.9848 25.4704C28.4125 26.4571 27.3994 27.0426 26.268 27.0426H5.69173C4.57345 27.0426 3.567 26.4703 3.00787 25.5033C2.44215 24.5232 2.43557 23.3523 3.00129 22.3656L13.3157 4.51262C13.8749 3.53249 14.8747 2.95361 16.0062 2.95361C17.131 2.95361 18.1375 3.53906 18.6966 4.5192L29.0045 22.3722C29.5571 23.3326 29.5505 24.4903 28.9848 25.4704Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5918 9.38627C14.809 9.60993 14.3223 10.3204 14.3223 11.1821C14.3617 11.7018 14.3946 12.228 14.4341 12.7477C14.5459 14.7277 14.6577 16.6682 14.7696 18.6482C14.809 19.3192 15.3287 19.806 15.9997 19.806C16.6706 19.806 17.1969 19.2863 17.2298 18.6088C17.2298 18.2009 17.2298 17.826 17.2693 17.4115C17.3416 16.142 17.4205 14.8724 17.4929 13.6028C17.5324 12.7806 17.6047 11.9583 17.6442 11.136C17.6442 10.84 17.6047 10.5769 17.4929 10.3138C17.1574 9.57704 16.3746 9.20208 15.5918 9.38627Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotStarted);
export default __webpack_public_path__ + "static/media/notStarted.c41fb604977174b2229588388ce738d2.svg";
export { ForwardRef as ReactComponent };